// Image Field
export const IMAGE_FIELD_DROP_ZONE_INPUT = 'image_field_drop_zone_input';
export const IMAGE_FIELD_DROP_ZONE_SPINNER = 'image_field_drop_zone_spinner';
export const IMAGE_FIELD_DROP_ZONE_PREVIEW = 'image_field_drop_zone_preview';
export const IMAGE_FIELD_DROP_ZONE_CONTENT = 'image_field_drop_zone_content';
export const IMAGE_FIELD_DROP_ZONE_CHANGE_IMAGE = 'image_field_drop_zone_change_image';
export const IMAGE_FIELD_DROP_ZONE_CROSS_ICON = 'image_field_drop_zone_cross_icon';
export const IMAGE_FIELD_UPLOAD_BUTTON_SPINNER = 'image_field_upload_button_spinner';
export const IMAGE_FIELD_UPLOAD_BUTTON = 'image_field_upload_button';
export const IMAGE_FIELD_UPLOAD_BUTTON_FILE_INPUT = 'image_field_upload_button_file_input';
export const IMAGE_FIELD_UPLOAD_BUTTON_IMAGE_DISPLAY = 'image_field_upload_button_image_display';